import React from "react";
import { motion } from "framer-motion";

/**
 * ChapterInterlude — quiet manuscript spread between chapters.
 *
 * Acts as a visual + emotional breath between major narrative beats. It
 * renders an engraving plate (richer than a simple icon) centered on the
 * pearl canvas with mono marginalia top and italic display marginalia
 * bottom. No CTA, no scroll cue. The reader's eye rests and continues.
 *
 * Mounted in HomePage between major chapters.
 */
export default function ChapterInterlude({
  plate,
  topLeft,
  topRight,
  caption,
  testid = "chapter-interlude",
  bg = "bg-pearl",
}) {
  return (
    <section
      data-testid={testid}
      className={`relative ${bg} text-tobacco py-12 md:py-16 border-t border-tobacco/10`}
      aria-hidden="true"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-12">
        <div className="flex items-baseline justify-between gap-4 mb-6 md:mb-8 font-mono text-[9.5px] md:text-[10px] tracking-widest2 uppercase text-tobacco/55">
          <span>{topLeft}</span>
          <span className="hidden md:inline italic font-display normal-case tracking-normal text-[13px] text-tobacco/65">
            {caption}
          </span>
          <span>{topRight}</span>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 1.6, ease: "easeOut" }}
          className="w-full flex justify-center"
        >
          <div className="w-full max-w-[920px]">{plate}</div>
        </motion.div>

        <div className="md:hidden mt-4 text-center italic font-display text-[14px] text-tobacco/65">
          {caption}
        </div>
      </div>
    </section>
  );
}
